import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Loader from '../../../../../Loader';
import { ShareableLink } from '../Types';
import CreateShareUrlStore from '../CreateShareUrlStore';
import TableBody from './TableBody';

interface Props {
  store: CreateShareUrlStore;
  programFamilyShareUrls: ShareableLink[];
}

function LinksTable({ store, programFamilyShareUrls }: Props) {
  switch (store.state.kind) {
    case 'error':
    case 'waiting':
    case 'ready':
      return (
        <div
          className="max-w-clientPortalMaxWidth mx-auto px-2.5 lg:px-12"
          data-intercom-target="shareable-links-table"
        >
          <table className="w-full lg:mb-12 mb-2.5">
            <thead>
              <tr className="text-left bg-muted p-5 border-b-1 border-border text-xs">
                <th className="p-5">
                  <T kind="Title" />
                </th>
                <th className="p-5">
                  <T kind="Course Type" />
                </th>
                <th className="p-5 w-1/5">
                  <T kind="Partner" />
                </th>
                <th className="p-5">
                  <T kind="Shareable Link" />
                </th>
                <th className="p-5"></th>
              </tr>
            </thead>
            <tbody>
              <TableBody programFamilyShareUrls={programFamilyShareUrls} />
            </tbody>
          </table>
        </div>
      );
    case 'creating':
      return <Loader className="h-full" />;
  }
}

export default observer(LinksTable);
